<template>
  <v-dialog v-model="show" width="500">
    <v-form lazy-validation ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">納入指示変更</span>
        </v-card-title>
        <v-card-actions>
          <v-btn :disabled="!valid" @click="submit">変更</v-btn>
          <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
        </v-card-actions>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <remote-autocomplete
                label="納入場所"
                url="warehouses/sjl-kv"
                v-model="finallyWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs12>
              <date-picker
                label="納入予定日"
                v-model="forecastDeliveryDate"
              ></date-picker>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[
                  (v) =>
                    !v ||
                    /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) ||
                    `4桁の数の有効時間を入力してください`,
                ]"
                clearable
                label="受入予定时间"
                v-model="forecastDeliveryTime"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    deliveryOrder: {},
    finallyWarehouseId: null,
    forecastDeliveryDate: null,
    forecastDeliveryTime: null,
    valid: true,
    errors: {
      SHIPMENT_HAS_CHANGED:
        '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
    },
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    submit() {
      var time = this.$insert(this.forecastDeliveryTime, 0, 2, ':')
      time = this.$insert(time, 0, 5, ':')
      time = time + '00'
      this.$http
        .put(
          `/delivery-orders/${this.deliveryOrder.id}/updateInfo?version=${
            this.deliveryOrder.version
          }`,
          {
            finallyWarehouseId: this.finallyWarehouseId,
            forecastDeliveryDate: this.forecastDeliveryDate,
            forecastDeliveryTime: time,
          }
        )
        .then(() => {
          this.$message('', '納入指示変更完了')
          this.$emit('refresh')
          this.show = false
        })
        .catch((res) => {
          this.$showError(res)
        })
    },
    popup(id) {
      this.$http.get(`/delivery-orders/do/${id}`).then((res) => {
        this.deliveryOrder = res.data
        this.finallyWarehouseId = this.deliveryOrder.finallyWarehouseId
        this.forecastDeliveryDate = this.deliveryOrder.forecastDeliveryDate
        this.forecastDeliveryTime =
          this.deliveryOrder.forecastDeliveryTime &&
          [
            this.deliveryOrder.forecastDeliveryTime.slice(0, 2),
            this.deliveryOrder.forecastDeliveryTime.slice(3, 5),
          ].join('')
        this.show = true
      })
    },
  },
}
</script>
